export default __webpack_public_path__ + "static/media/vinium.b04cdc8b.svg";